import {Component, OnInit} from '@angular/core';
import {Service} from '../../../models/service';
import {UtilsService} from '../../../services/utils.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ServicesService} from '../../../services/services.service';
import {UploadService} from '../../../services/upload.service';
import {FileService} from '../../../services/file.service';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-service-view',
  templateUrl: './service-view.component.html',
  styleUrls: ['./service-view.component.scss']
})
export class ServiceViewComponent implements OnInit {

  service: Service = new Service();
  options = [];

  selectedFile: File;
  imageDescription = '';

  modelChanged: Subject<string> = new Subject<string>();

  constructor(private servicesService: ServicesService,
              private utilsService: UtilsService,
              private uploadService: UploadService,
              private fileService: FileService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit() {
    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateService());

    const id = this.route.snapshot.paramMap.get('id');
    this.servicesService.findOneService(id).subscribe(result => {
      if (result && result.data) {
        this.service = JSON.parse(JSON.stringify(result.data['service']));
        this.options = this.service.options;
        if (this.service.photos && this.service.photos.length > 0) {
          this.imageDescription = this.service.photos[0].description;
        }
        this.utilsService.openSnackBar('Service Loaded !!', '');
      }
    });
  }

  dataChanged() {
    this.modelChanged.next();
  }

  updateService() {
    this.service.options = this.options.map(item => item.display ? item.display : item);
    const requiredSuccess = this.utilsService.validateRequiredFields(this.service.type, this.service.options);
    if (requiredSuccess) {
      this.servicesService.updateService(this.service).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Service Updated !!', '');
          // this.router.navigate(['/services']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update service.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }


  deleteService() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.servicesService.deleteService(this.service).subscribe(({data}) => {
      this.utilsService.openSnackBar('Service Deleted !!', '');
      this.router.navigate(['/services']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete service.', '');
      console.log('there was an error sending the query', error);
    });
  }

  selectFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
    }
  }

  upload() {
    this.uploadService.issuePreSignedURL(this.selectedFile).subscribe(result => {
      this.uploadService.uploadFileToS3(result['signedRequest'], this.selectedFile).subscribe(data => {
        if (data && data.url) {
          const file = {
            path: result['fileName'],
            mimetype: this.selectedFile.type,
            serviceId: this.service.id,
          };
          if (this.service.photos && this.service.photos.length === 0) {
            this.createFile(file);
          } else {
            this.updateFile(file);
          }
        }
      });
    });
  }

  createFile(file) {
    this.fileService.createFile(file).subscribe((response) => {
      if (response.errors && response.errors.length > 0) {
        const errors = response.errors.map(err => err.message);
        this.utilsService.openSnackBar(errors, '');
      } else {
        this.service.photos = [response.data.createFile];
        this.utilsService.openSnackBar('Photo uploaded!!', '');
      }
    }, (error) => {
      this.utilsService.openSnackBar('Unable to upload photo.', '');
      console.log('there was an error sending the query', error);
    });
  }

  updateDescription() {
    this.service.photos[0]['description'] = this.imageDescription;
    this.updateFile(this.service.photos[0]);
  }

  updateFile(file) {
    file['id'] = this.service.photos[0].id;
    file['description'] = this.service.photos[0]['description'] ;
    this.fileService.updateFile(file).subscribe((response) => {
      if (response.errors && response.errors.length > 0) {
        const errors = response.errors.map(err => err.message);
        this.utilsService.openSnackBar(errors, '');
      } else {
        this.service.photos[0].path = file.path;
        this.service.photos[0].mimetype = file.mimetype;
        this.utilsService.openSnackBar('Photo uploaded!!', '');
      }
    }, (error) => {
      this.utilsService.openSnackBar('Unable to upload photo.', '');
      console.log('there was an error sending the query', error);
    });
  }

  deleteFile() {
    if (this.service.photos[0].id) {
      this.fileService.delete(this.service.photos[0]).subscribe(({data}) => {
        this.service.photos = [];
        this.utilsService.openSnackBar('Photo Deleted !!', '');
      }, (error) => {
        this.utilsService.openSnackBar('Unable to delete photo.', '');
        console.log('there was an error sending the query', error);
      });
    } else {
      this.utilsService.openSnackBar('Unable to delete photo.', '');
    }
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/services/services-view/service-view.component.ts